export default "__VITE_ASSET__CRJHqukO__"